export const selectFabricArt = ({fabricDesign}) => fabricDesign.fabricArt;

export const selectOrigFabricArt = ({fabricDesign}) => fabricDesign.originalFabricArt;

export const selectSectionOverride = ({fabricDesign}) => fabricDesign.sectionOverride;

export const selectEnvelopeStickers = ({fabricDesign}) => fabricDesign.envelopeStickers;

export const selectOriginalFabricArt = ({fabricDesign}) => fabricDesign.originalFabricArt;

export const selectBackgroundId = ({fabricDesign}) => fabricDesign.backgroundId;

export const selectBackgroundColor = ({fabricDesign}) => fabricDesign.backgroundColor;

export const selectStampId = ({fabricDesign}) => fabricDesign.stampId;

export const selectEnvelopeId = ({fabricDesign}) => fabricDesign.envelopeId || 'wht01';

export const selectLinerId = ({fabricDesign}) => fabricDesign.linerId;

export const selectCurrentSection = ({fabricDesign}) => fabricDesign.currentSection;

export const selectUyoVariation = ({fabricDesign}) => fabricDesign.uyoVariation;

export const selectLoaded = ({fabricDesign}) => fabricDesign?.loaded ?? false;

export const selectActiveCardEditor = ({fabricDesign}) => fabricDesign.activeCardEditor;

export const selectTouched = ({fabricDesign}) => fabricDesign.touched;

export const selectPristine = ({fabricDesign}) => fabricDesign.pristine;
export const selectPristineUyo = ({fabricDesign}) => fabricDesign.pristineUyo;
export const selectIsPristineUyo = ({fabricDesign}) =>
  Object.values(fabricDesign.pristineUyo).some((v) => v === true);
export const selectCountOfUyoImages = (state) => {
  const objects =
    state.fabricDesign.originalFabricArt?.objects || state.eventDetails.fabric_design_data?.objects;
  return objects ? objects.filter((obj) => obj.type === 'uYOImage').length : 0;
};
export const selectAllFieldsEdited = ({fabricDesign}) => fabricDesign.allFieldsEdited;

export const selectHasTextbox = ({fabricDesign}) => fabricDesign.hasTextbox;

export const selectPremiumFeaturesPristine = ({fabricDesign}) =>
  fabricDesign.premiumFeaturesPristine;

export const selectPremiumFeaturesWarning = ({fabricDesign}) => fabricDesign.premiumFeaturesWarning;

export const selectIgnorePremiumWarning = ({fabricDesign}) => fabricDesign.ignorePremiumWarning;

export const selectSavingStep = ({fabricDesign}) => fabricDesign.savingStep;

export const selectTextAreaOpen = ({fabricDesign}) => fabricDesign.textAreaOpen;

export const selectEditingMobile = ({fabricDesign}) => fabricDesign.editingMobile;

export const selectEditorDisabled = ({fabricDesign}) => fabricDesign.editorDisabled;

export const selectRecentTextColors = ({fabricDesign}) => fabricDesign.recentTextColors;

export const selectRecentBackgroundColors = ({fabricDesign}) => fabricDesign.recentBackgroundColors;

export const selectEditingUyoMobile = ({fabricDesign}) => fabricDesign.editingUyoMobile;

export const selectForceShowOnboardingModal = ({fabricDesign}) =>
  fabricDesign.forceShowOnboardingModal;

export const selectFabricArtBackgroundImage = ({fabricDesign}) =>
  fabricDesign.fabricArt?.backgroundImage;

export const selectShouldUseCachedGalleryPhoto = ({fabricDesign}) =>
  fabricDesign.shouldUseCachedGalleryPhoto;

export const selectIsFullDyo = ({fabricTemplate}) =>
  fabricTemplate.templateName.includes('general-full') &&
  fabricTemplate.templateName.includes('dyo');

export const selectDefaultEnvelope = ({fabricDesign}) => fabricDesign.defaultEnvelope;

export const selectDefaultLiner = ({fabricDesign}) => fabricDesign.defaultLiner;

export const selectDefaultBackground = ({fabricDesign}) => fabricDesign.defaultBackground;

export const selectDefaultStamp = ({fabricDesign}) => fabricDesign.defaultStamp;

export const selectSelectedEnvelope = (state) => {
  const {envelopeId} = state.fabricDesign;
  if (
    !envelopeId ||
    !state?.fabricTemplate?.allEnvelopes ||
    state?.fabricTemplate?.allEnvelopes?.length === 0
  )
    return undefined;
  return (
    state.fabricTemplate.allEnvelopes.find((envelope) => envelope.id === envelopeId) ??
    state.fabricTemplate?.allEnvelopes?.[0]
  );
};

export const selectSelectedStamp = (state) => {
  const {stampId} = state.fabricDesign;
  if (
    !stampId ||
    !state?.fabricTemplate?.allStamps ||
    state?.fabricTemplate?.allStamps?.length === 0
  )
    return undefined;
  return (
    state.fabricTemplate.allStamps.find((stamp) => stamp.id === stampId) ??
    state.fabricTemplate?.allStamps?.[0]
  );
};

export const selectSelectedLiner = (state) => {
  const {linerId} = state.fabricDesign;
  if (!linerId || !state?.fabricTemplate?.allLiners) return undefined;
  return state.fabricTemplate.allLiners.find((liner) => liner.id === linerId);
};

export const selectSelectedBackground = (state) => {
  const {backgroundId} = state.fabricDesign;
  if (!backgroundId || !state?.fabricTemplate?.allBackgrounds) return undefined;
  return state.fabricTemplate.allBackgrounds.find((bg) => bg.id === backgroundId);
};

export const selectUsedPremiumFeature = (state) => state.fabricDesign.usedPremiumFeature;

export const selectShouldTogglePremiumBackground = ({fabricDesign}) =>
  fabricDesign.shouldTogglePremiumBackground;

export const selectPristineBackground = ({fabricDesign}) => fabricDesign.pristineBackground;

export const selectShowTextTooltip = ({fabricDesign}) => fabricDesign.showSampleTextTooltip;

export const selectHasStickersChanged = ({fabricDesign}) =>
  JSON.stringify(fabricDesign?.envelopeStickers || {}) !==
  JSON.stringify(fabricDesign?.init?.envelopeStickers);

export const selectInitEnvelopeStickers = ({fabricDesign}) => fabricDesign.init.envelopeStickers;

export const selectHasBackgroundChanged = ({fabricDesign}) =>
  fabricDesign.backgroundId !== fabricDesign.init.backgroundId ||
  fabricDesign.backgroundColor !== fabricDesign.init.backgroundColor;

export const selectInitBackgroundColor = ({fabricDesign}) => fabricDesign.init.backgroundColor;

export const selectShowMatchingSetPreview = (state) => state.fabricDesign.showMatchingSetPreview;

export const selectPristineEnvelopeDesign = ({fabricDesign}) => fabricDesign.pristineEnvelopeDesign;

export const selectIsFilledUyo = ({fabricDesign, eventDetails}) => {
  const objects = fabricDesign.fabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return Boolean(objects?.some((obj) => obj.type === 'uYOImage' && !obj.variant && obj.src));
};

export const selectIsUyo = ({fabricDesign, eventDetails}) => {
  const objects =
    fabricDesign.originalFabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return Boolean(objects?.some((obj) => obj.type === 'uYOImage'));
};

export const selectDesignHasLogo = ({fabricDesign, eventDetails}) => {
  const objects =
    fabricDesign.originalFabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return objects?.some((obj) => obj.type === 'uYOImage' && obj.variant === 'logo');
};

export const selectIsLogoFilled = ({fabricDesign, eventDetails}) => {
  const objects = fabricDesign.fabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return Boolean(
    objects?.some(
      (obj) =>
        obj.type === 'uYOImage' &&
        obj.variant === 'logo' &&
        obj.src &&
        obj._originalObject &&
        obj.src !== obj._originalObject.src
    )
  );
};

export const selectDesignHasLogoAndUyo = ({fabricDesign, eventDetails}) => {
  const objects =
    fabricDesign.originalFabricArt?.objects || eventDetails.fabric_design_data?.objects;
  const uyoObjects = objects?.filter((obj) => obj.type === 'uYOImage') ?? [];
  return uyoObjects.some((obj) => obj.variant === 'logo') && uyoObjects.some((obj) => !obj.variant);
};

export const selectHasEnvelopeChanged = ({fabricDesign}) => {
  if (fabricDesign.init) return fabricDesign.init.envelopeId !== fabricDesign.envelopeId;
  return false;
};

export const selectHasLinerIdChanged = ({fabricDesign}) => {
  if (fabricDesign.init) return fabricDesign.init.linerId !== fabricDesign.linerId;
  return false;
};

export const selectHasStampIdChanged = ({fabricDesign}) =>
  fabricDesign.init.stampId !== fabricDesign.stampId;

export const selectIsPristineUyoByFindingId = ({fabricDesign}) => {
  const uyoImageObject = fabricDesign.fabricArt.objects.find((obj) => obj.type === 'uYOImage');
  if (!uyoImageObject) return undefined;

  let uyoImageObjectId = uyoImageObject.id;

  if (uyoImageObjectId.includes('container')) {
    [uyoImageObjectId] = uyoImageObjectId.split('-');
  }

  return fabricDesign.pristineUyo[uyoImageObjectId];
};

export const selectRsvpOptional = ({fabricTemplate}) => fabricTemplate.rsvpOptional;
